import { render, staticRenderFns } from "./status.vue?vue&type=template&id=6ede7e4a&scoped=true"
import script from "./status.vue?vue&type=script&lang=js"
export * from "./status.vue?vue&type=script&lang=js"
import style0 from "./status.vue?vue&type=style&index=0&id=6ede7e4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ede7e4a",
  null
  
)

export default component.exports